import { getBaseUrl } from 'utils/helperMethods';

//URLS
export enum Urls {
    depletionBarChartUrl = 'depletion',
    depletionDrilldownUrl = 'depletion/attr_timeseries',
}

const baseUrl = getBaseUrl();

export const filterUrls = {
    getAttributeNamesUrl: baseUrl + 'dimension/attribute_names',
};

export const roiTrackerUrls = {
    investmentTypeDropdownUrl: baseUrl + 'media/investment_types',
    roiTrackerGraphUrl: baseUrl + 'media/graph_investments_data',
    roiTrackerTableUrl: baseUrl + 'media/tracker_table_data',
};

export const bumpReportUrls = {
    incrementsPromoUrl: baseUrl + 'bump_report/incremental_promo_trends',
    incrementsPromoExportUrl: baseUrl + 'bump_report/incremental_promo_trends_export',
    groupByUrl: baseUrl + 'bump_report/top_attribute_trends',
    groupByExportUrl: baseUrl + 'bump_report/top_attributes_trend_export',
    bumpReportCalenderUrl: baseUrl + 'bump_report/promo_calendar',
    lineChartUrl: baseUrl + 'bump_report/derived_trends',
    mediaTypesUrl: baseUrl + 'bump_report/media_types',
};

export const commercialForecastUrls = {
    graphDataUrl: baseUrl + 'commercial_forecast/graph_data',
    tableDataUrl: baseUrl + 'commercial_forecast/table_data',
    trendGraphUrl: baseUrl + 'commercial_forecast/data_trend',
};

export const PVMUrls = {
    YearDropdownUrl: baseUrl + 'pvm/max_date',
    PlansDropdownUrl: baseUrl + 'pvm/comparison_list',
    FeatureGroupsDataUrl: baseUrl + 'pvm/feature_groups_data',
    FeatureDataUrl: baseUrl + 'pvm/features_data',
    FeatureTableDataUrl: baseUrl + 'pvm/table_data',
    GroupTimeSeriesUrl: baseUrl + 'pvm/group_timeseries_data',
    FeatureTimeSeriesUrl: baseUrl + 'pvm/feature_timeseries_data',
    FeatureAttributeDataUrl: baseUrl + 'pvm/feature_attribute_data',
};

export const PortfolioUrls = {
    MediaTypesUrl: baseUrl + 'media/media_types',
    MediaTypesDataUrl: baseUrl + 'media/media_roi_analysis_data',
    roiAnalysisKpiDataUrl: baseUrl + 'roi_analysis/kpis',
    roiAnalysisTableDataUrl: baseUrl + 'roi_analysis/table_data',
    roiAnalysisTableDataExportUrl: baseUrl + 'roi_analysis/table_data_export',
};

export const priceCurveUrls = {
    levelStatus: baseUrl + 'price_curve/levels_enabled_status',
};

// price simulator v2 urls
export const pricingSimulatorUrls = {
    // get calls
    getDimensionConfigDataUrl: baseUrl + 'pricing_simulator_v2/project/get_project_dimensions',
    getAllProjectsUrl: baseUrl + 'pricing_simulator_v2/project/project_details',
    getProjectAccess: baseUrl + 'pricing_simulator_v2/project',
    getAllScenariosUrl: baseUrl + 'pricing_simulator_v2/scenario',
    getProjectFiltersUrl: baseUrl + 'pricing_simulator_v2/project/get_project_filters',
    getLenseConfigUrl: baseUrl + 'pricing_simulator_v2/lens_kpi/get_lens_kpis_config',
    getSingleProjectDetailsUrl: baseUrl + 'pricing_simulator_v2/project/get_project_details_by_id',
    getSingleScenarioDetailsUrl: baseUrl + 'pricing_simulator_v2/scenario/details',
    getSingleProjectDetailsByScenarioIdUrl: baseUrl + 'pricing_simulator_v2/project/get_project_details_by_scenario_id',
    getSingleScenarioLenseDataUrl: baseUrl + 'pricing_simulator_v2/scenario/fetch_scenario_data',
    getFilterAttributes: baseUrl + 'pricing_simulator_v2/scenario/attribute_names',
    getScenarioStatusById: baseUrl + 'pricing_simulator_v2/scenario/scenario_status',
    // post calls
    editKpiUrl: baseUrl + 'pricing_simulator_v2/scenario/apply_changes',
    postUpdateLenseConfig: baseUrl + 'pricing_simulator_v2/lens_kpi/update_lens_kpi_config',
    postUpdateLastViewedLense: baseUrl + 'pricing_simulator_v2/lens_kpi/update_last_viewed_lens',
    createProjectUrl: baseUrl + 'pricing_simulator_v2/project/create_project',
    updateProjectUrl: baseUrl + 'pricing_simulator_v2/project/update_project',
    updateFilterUrl: baseUrl + 'pricing_simulator_v2/scenario/update_filter',
    updateScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/update_scenario',
    updateDelistOrCompFollowStatusUrl: baseUrl + 'pricing_simulator_v2/scenario/update_scenario_column',
    simulateScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/simulate',
    createNewScenario: baseUrl + 'pricing_simulator_v2/scenario/create_scenario',
    duplicateScenario: baseUrl + 'pricing_simulator_v2/scenario/duplicate_scenario',
    resetScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/reset_scenario',
    reloadScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/reload_scenario',
    //delete calls
    deleteScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/delete_scenario',
    //export calls
    exportScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario/export_scenario_data',
    exportScenarioStatusUrl: baseUrl + 'pricing_simulator_v2/scenario/export_scenario_status',
    getScenarioDataCount: baseUrl + 'pricing_simulator_v2/scenario/fetch_scenario_data_count',
    uploadScenarioExcel: baseUrl + 'pricing_simulator_v2/scenario/upload_scenario_template',
    downloadTemplate: baseUrl + 'pricing_simulator_v2/scenario/download_template',
    getUploadStatus: baseUrl + 'pricing_simulator_v2/scenario/get_upload_status',
};

//analytics urls
export const pricingAnalyticsUrls = {
    addBaseScenarioUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/create_update_report',
    getReportsListUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/list_reports',
    getReportMetaDataUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/report_metadata',
    getChangeAnalyticsDataUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/fetch_change_analytics_data',
    getCategoryMovementKpiChartDataUrl:
        baseUrl + 'pricing_simulator_v2/scenario_analytics/fetch_category_movement_data',
    getCategoryMovementChartByLevelDataUrl:
        baseUrl + 'pricing_simulator_v2/scenario_analytics/fetch_category_movement_by_level',
    getGlobalKPIsDataUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/fetch_global_kpi_tiles',
    deleteGlobalKPIUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/remove_global_kpi',
    updateReportNameUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/rename_report',
    getReportAccess: baseUrl + 'pricing_simulator_v2/scenario_analytics',

    //comparison urls
    getComparisonMetaDataUrl:
        baseUrl + 'pricing_simulator_v2/scenario_analytics/get_report_comparison_scenario_details',
    getHeatmapTableDataUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/get_heatmap_comparison_data',
    updateReportScenarioList:
        baseUrl + 'pricing_simulator_v2/scenario_analytics/update_report_comparison_scenario_list',
    updateReportFilter: baseUrl + 'pricing_simulator_v2/scenario_analytics/update_report_filter',
    deleteScenarioFromReportUrl: baseUrl + 'pricing_simulator_v2/scenario_analytics/remove_scenario_from_comparison',
    getTierViewData: baseUrl + 'pricing_simulator_v2/scenario_analytics/get_tier_view_data',
};

//tpo urls
export const tradePromoOptimizationUrls = {
    getKpiConfigDataUrl: baseUrl + 'promo_recommendation/tpo/tpo_kpi_view_config',
    getPlaybookKpiConfigDataUrl: baseUrl + 'promo_recommendation/tpo/get_playbook_kpis',
    getAllPlansUrl: baseUrl + 'promo_recommendation/tpo/plan_details',
    getPlanFilters: baseUrl + 'promo_recommendation/tpo/get_plan_filters',
    getPlanMetaDataUrl: baseUrl + 'promo_recommendation/tpo/plan_meta_data',
    getPlanEditMetaDataUrl: baseUrl + 'promo_recommendation/tpo/plans',
    getPromoKpiConfigDataUrl: 'https://jsonplaceholder.typicode.com/todos',
    createPlanUrl: baseUrl + 'promo_recommendation/tpo/create_promo_plan',
    updatePlanUrl: baseUrl + 'promo_recommendation/tpo/update_promo_plan',
    getOfferDataUrl: baseUrl + 'promo_recommendation/tpo/get_offer_type',
    getPromosByEventId: baseUrl + 'promo_recommendation/tpo/get_promos_by_event_id',
    getPromoDetailsByPromoId: baseUrl + 'promo_recommendation/tpo/get_promo_details_by_promo_id',
    postPromoDetails: baseUrl + 'promo_recommendation/tpo/upsert_event_promo',
    getPromoMetricsConfigUrl: baseUrl + 'promo_recommendation/tpo/promo_tactics_config',
    getMetricsRecommendedValues: baseUrl + 'promo_recommendation/tpo/metrics_recommended_values',
    getAttributeListUrl: baseUrl + 'promo_recommendation/tpo/get_event_filters_list',
    getOptimizationOrgValues: baseUrl + 'promo_recommendation/tpo/get_optimization_original_vals',
    getObjectives: baseUrl + 'promo_recommendation/tpo/get_objectives',
    runOptimization: baseUrl + 'promo_recommendation/tpo/run_optimization',
    getEventDataByIdUrl: baseUrl + 'promo_recommendation/tpo/event_meta_data',
    getCalenderDataUrl: baseUrl + 'promo_recommendation/tpo/calendar_data',
    getKpiTableDataUrl: baseUrl + 'promo_recommendation/tpo/kpi_table',
    createEditEventUrl: baseUrl + 'promo_recommendation/tpo/upsert_event',
    createEditEventLibraryUrl: baseUrl + 'promo_recommendation/tpo/upsert_event_in_event_library',
    getEventsForEventsLibraryUrl: baseUrl + 'promo_recommendation/tpo/fetch_events_from_event_library',
    importEventsLibraryUrl: baseUrl + 'promo_recommendation/tpo/import_events_from_library',
    importEventsFromPlanUrl: baseUrl + 'promo_recommendation/tpo/import_events_from_plans',
    getPlansForImportUrl: baseUrl + 'promo_recommendation/tpo/fetch_plans_for_events_import',
    getEventsByPlanIdForImportUrl: baseUrl + 'promo_recommendation/tpo/fetch_events_from_plans',
    getOptimizationResult: baseUrl + 'promo_recommendation/tpo/get_optimized_results',
    // getRbacDataUrl: 'https://dummyjson.com/c/fd62-13f2-449b-b558',
    // getRbacDataUrl: 'https://rbac-service-eastus-staging.azure.dynamicdemand.ai/rbac/feature_level_data_restrictions',
    getRbacDataUrl: 'https://rbac-service-eastus-staging.asper.dynamicdemand.ai/rbac/feature_level_data_restrictions',
    deleteEventUrl: baseUrl + 'promo_recommendation/tpo/delete_event',
    deletePromoUrl: baseUrl + 'promo_recommendation/tpo/delete_promo',
    syncTpoUrl: baseUrl + 'promo_recommendation/tpo/delete_plan_for_sync',
    getPlaybookTableDataUrl: baseUrl + 'promo_recommendation/tpo/get_playbook_kpis_data',
    getPromoLibraryTableDataUrl: baseUrl + 'promo_recommendation/tpo/get_promo_library_kpis_data',
    getPromoLibraryTableDataExportUrl: baseUrl + 'promo_recommendation/tpo/get_promo_library_kpis_data_export',
    getPromoLibraryKpiUrl: baseUrl + 'promo_recommendation/tpo/get_promo_library_kpis',
    // getMechanicsLibraryTableDataUrl: baseUrl + 'promo_recommendation/tpo/get_mechanic_library_data',
    getProductConstraintsTableDataUrl: baseUrl + 'promo_recommendation/tpo/get_product_constraints_data',
    updatePlaybookDataUrl: baseUrl + 'promo_recommendation/tpo/update_playbook',
    updatePromoLibraryUrl: baseUrl + 'promo_recommendation/tpo/update_promo_library',
    optimizePlan: baseUrl + 'promo_recommendation/tpo/optimize_plan',
    getOptimizationStatus: baseUrl + 'promo_recommendation/tpo/get_optimization_status',
    getExportDataUrl: baseUrl + 'promo_recommendation/tpo/export_tpo_data',
    getOptimizationId: baseUrl + 'promo_recommendation/tpo/get_optimization_id',
    getSyncOptimizationToTpoUrl: baseUrl + 'promo_recommendation/tpo/sync_tpo_to_optimized_plan',
    getDistinctPlanYearsUrl: baseUrl + 'promo_recommendation/tpo/distinct_plan_years',
    getPlansListUrl: baseUrl + 'promo_recommendation/tpo/comparison_plans_list',
    getPlansComparisonTableDataUrl: baseUrl + 'promo_recommendation/tpo/plans_comparison_table_data',
    getUpliftRecommendation: baseUrl + 'promo_recommendation/tpo/model_uplift',
    getLastUpdatedAtPollingUrl: baseUrl + 'promo_recommendation/tpo/get_updated_at_upsert_promo',
    getKeepDatesPromoUrl: baseUrl + 'promo_recommendation/tpo/keep_dates_and_promos',
    getPromoLibraryUiDimensions: baseUrl + 'promo_recommendation/tpo/get_promo_library_ui_dimensions',
    getExportKpiViewUrl: baseUrl + 'promo_recommendation/tpo/kpi_table_export',
    getAttributeNames: baseUrl + 'promo_recommendation/tpo/attribute_names_v2',
};
